import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'
import { REDUCER_NAME } from './const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const FIND_IMAGE_VERSION_LIST_REQUEST = NS + 'FIND_IMAGE_VERSION_LIST_REQUEST'
export const FIND_IMAGE_VERSION_LIST_SUCCESS = NS + 'FIND_IMAGE_VERSION_LIST_SUCCESS'
export const FIND_IMAGE_VERSION_LIST_ERROR = NS + 'FIND_IMAGE_VERSION_LIST_ERROR'

export const UPLOAD_CUSTOMER_IMAGE_REQUEST = NS + 'UPLOAD_CUSTOMER_IMAGE_REQUEST'
export const UPLOAD_CUSTOMER_IMAGE_SUCCESS = NS + 'UPLOAD_CUSTOMER_IMAGE_SUCCESS'
export const REUPLOAD_CUSTOMER_IMAGE_SUCCESS = NS + 'REUPLOAD_CUSTOMER_IMAGE_SUCCESS'
export const UPLOAD_CUSTOMER_IMAGE_ERROR = NS + 'UPLOAD_CUSTOMER_IMAGE_ERROR'

export const ROTATE_CUSTOMER_IMAGE_REQUEST = NS + 'ROTATE_CUSTOMER_IMAGE_REQUEST'
export const ROTATE_CUSTOMER_IMAGE_SUCCESS = NS + 'ROTATE_CUSTOMER_IMAGE_SUCCESS'
export const ROTATE_CUSTOMER_IMAGE_ERROR = NS + 'ROTATE_CUSTOMER_IMAGE_ERROR'

export const TOGGLE_IMAGE_VIEW = NS + 'TOGGLE_IMAGE_VIEW'

export const CHANGE_NEW_IMAGE_TYPE = NS + 'CHANGE_NEW_IMAGE_TYPE'

export const SET_IMAGE_TYPE_META_DATA_REQUEST = NS + 'SET_IMAGE_TYPE_META_DATA_REQUEST'
export const SET_IMAGE_TYPE_META_DATA_SUCCESS = NS + 'SET_IMAGE_TYPE_META_DATA_SUCCESS'
export const SET_IMAGE_TYPE_META_DATA_ERROR = NS + 'SET_IMAGE_TYPE_META_DATA_ERROR'

export const SET_SELECTED_IMAGE_TYPE = NS + 'SET_SELECTED_IMAGE_TYPE'
export const SET_CURRENT_STEP = NS + 'SET_CURRENT_STEP'
export const SET_SLIDE_INDEX = NS + 'SET_SLIDE_INDEX'

export const DELETE_CUSTOMER_IMAGE_REQUEST = NS + 'DELETE_CUSTOMER_IMAGE_REQUEST'
export const DELETE_CUSTOMER_IMAGE_SUCCESS = NS + 'DELETE_CUSTOMER_IMAGE_SUCCESS'
export const DELETE_CUSTOMER_IMAGE_ERROR = NS + 'DELETE_CUSTOMER_IMAGE_ERROR'



// WEBPACK FOOTER //
// ./src/modules/customer/state/image/type.js